// extracted by mini-css-extract-plugin
module.exports = {"title":"SignUpForm_title__CfODH","stepTwo":"SignUpForm_stepTwo__x4K9y"};